export interface IDictatedRequest {
  caseLineItemId: number
  dictatedDate: Date
}

export class DictatedRequest implements IDictatedRequest {
  public caseLineItemId: number
  public dictatedDate: Date
}
